import React from 'react'

import { faMap } from '@fortawesome/pro-regular-svg-icons'
import { Modal } from 'govwell-ui'

import EntityVersionSearchMap, {
  EntityVersionSearchMapProps,
} from 'src/components/Selects/EntityVersionSearch/EntityVersionSearchMap'
import { getSearchEntityLayersCaption } from 'src/utils/gis'

type Props = EntityVersionSearchMapProps & {
  onClose: () => void
}

const EntityVersionSearchMapModal = (props: Props) => {
  const { onClose, ...entityVersionSearchMapProps } = props
  const { entityLayers } = entityVersionSearchMapProps

  const modalHeader = getSearchEntityLayersCaption(entityLayers)
  return (
    <Modal width="70vw" className="min-w-[350px]" onClose={onClose}>
      <Modal.Header icon={faMap}>{modalHeader}</Modal.Header>
      <Modal.Content>
        <EntityVersionSearchMap {...entityVersionSearchMapProps} />
      </Modal.Content>
    </Modal>
  )
}

export default React.memo(EntityVersionSearchMapModal)
